import { render, staticRenderFns } from "./associatedOrder.vue?vue&type=template&id=952d853c&scoped=true"
import script from "./associatedOrder.vue?vue&type=script&lang=js"
export * from "./associatedOrder.vue?vue&type=script&lang=js"
import style0 from "./associatedOrder.vue?vue&type=style&index=0&id=952d853c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952d853c",
  null
  
)

export default component.exports